import styled from '@emotion/styled'
import { colors, typography } from '@resiliatech/birdsong'
import { Box, Typography } from '@mui/material'

export const GoalModalContainer = styled.div`
  background-color: ${colors.background.secondaryBackground};
  border-radius: 4px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 40px;
  width: 688px;
`

export const Header = styled.div`
  ${typography.up2.semiBoldSans};
`

export const Inputs = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  height: 100%;
  padding: 20px 0;
`

export const DatePickers = styled.div`
  display: flex;
  gap: 24px;
`

export const Buttons = styled.div`
  display: flex;
  gap: 24px;
  justify-content: flex-end;
`

export const ModalButtonContainer = styled.div`
  display: flex;
  gap: 24px;
  justify-content: flex-end;
  margin-top: 15px;
`

export const DeleteGoalContentContainer = styled.div`
  align-items: center;
  background-color: ${colors.background.secondaryBackground};
  border-radius: 4px;
  display: flex;
  flex-direction: column;
  gap: 12px;
  justify-content: space-between;
  padding: 20px;
  width: 768px;
`

export const FlexRowColumn = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  gap: 12px;
`

export const Text = styled.div`
  ${typography.baseline.regularSans};
  text-align: center;
`

export const ShareFunderText = styled.p`
  ${typography.baseline.regularSans};
  margin-right: -10px;
`

export const BoldText = styled.span`
  font-weight: 700;
`

export const FunderCheckBox = styled(Box)`
  display: flex;
  align-items: center;
`

export const UnshareWarning = styled(Box)`
  ${typography.down1.regularSans};
  display: flex;
  padding: 12px 16px;
  align-items: center;
  background-color: ${colors.warning.light};
  border-radius: 4px;
  color: ${colors.warning.main};
  margin-top: -20px;
`

export const TooltipBox = styled(Box)`
  display: flex;
  flex-direction: column;
`

export const TooltipText = styled.span``

export const CategorySelector = styled(Typography)`
  display: inline;
  ${typography.baseline.regularSans};
  & > span {
    color: red;
  }
`
